// extracted by mini-css-extract-plugin
export default {"groupsTabContainer":"GroupsTab_groupsTabContainer__3aAH8","nextStepBtn":"GroupsTab_nextStepBtn__nNZM2","groupItem":"GroupsTab_groupItem__Tq9au"};